// Owner: data-model-formula (wave 2); registry conversion by ui-layers. The formula editor opens over
// any page from `openFormulaEditor(...)` or from the URL
// `/settings/objects/<key>?formula=<field key | new>` (deep links from the object builder).
import { useRouterState } from '@tanstack/react-router';
import { lazy, useEffect } from 'react';
import { FORMULA_SEARCH_PARAM, NEW_FORMULA } from '../features/formula/open';
import { defineGlobalLayer, openLayer } from '../shell/overlays';

export const FORMULA_OBJECT_PATH = /^\/settings\/objects\/([a-z][a-z0-9_]*)(?:\/|$)/;

/** Opens the layer for the deep link (light: reads the URL only). */
function FormulaDeepLink() {
  const location = useRouterState({ select: (s) => s.location });
  const param = (location.search as Record<string, unknown>)[FORMULA_SEARCH_PARAM];
  const objectKey = FORMULA_OBJECT_PATH.exec(location.pathname)?.[1];
  useEffect(() => {
    if (typeof param === 'string' && param && objectKey)
      openLayer('formula', { objectKey, fieldKey: param === NEW_FORMULA ? null : param });
  }, [param, objectKey]);
  return null;
}

export default defineGlobalLayer({
  id: 'formula',
  component: lazy(() => import('./formula-editor.layer')),
  Effect: FormulaDeepLink,
});
